import type { ActionContext } from 'vuex'

import type {
  ActionClass,
  InstanceManagementState,
  InstanceSearchServiceConfig,
} from '../../../models'
import type { InstanceSearchManagementService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { INSTANCE_MANAGEMENT_CONSTS } from '../instance-management.consts'

export class ReadSearchServiceConfigAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<InstanceManagementState, any>,
    instance: string,
  ): Promise<InstanceSearchServiceConfig> {
    const instanceSearchManagementService = CONTAINER.get<InstanceSearchManagementService>(
      TYPES.InstanceSearchManagementService,
    )
    const config = await instanceSearchManagementService.readConfig(instance)
    commit(INSTANCE_MANAGEMENT_CONSTS.mutations.setSearchServiceConfig, config)
    return config
  }
}
